let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3vnHc")).then(() => parcelRequire('764ST'));